import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h4", null, "Add User to Account", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_3 = { class: "d-block" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_5 = { class: "d-block" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" User Role ")
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<option value=\"\">Select a role...</option><option value=\"reviewer\">Reviewer</option><option value=\"editor\">Editor</option><option value=\"manager\">Manager</option><option value=\"administrator\">Administrator</option>", 5)
const _hoisted_12 = { class: "d-block" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Account ID ")
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = {
  key: 0,
  class: "ms-2 text-success"
}
const _hoisted_16 = {
  key: 1,
  class: "ms-2 text-danger"
}
const _hoisted_17 = {
  key: 0,
  class: "meter-warning alert alert-danger mt-3"
}

import { ref } from 'vue';


export default _defineComponent({
  setup(__props) {

const email = ref('');
const role = ref('');
const account_id = ref('');
const isSubmitting = ref(false);
const errorMessage = ref('');
const isCheckingAccount = ref(false);
const accountName = ref('');
const accountCheckError = ref('');

const checkAccountName = async () => {
    if (!account_id.value) {
        return;
    }

    isCheckingAccount.value = true;
    accountName.value = '';
    accountCheckError.value = '';

    try {
        const response = await (window as any).$app.api.get(`/accounts/${account_id.value}`);
        accountName.value = response.data.name || 'No name available';
    } catch (error) {
        console.error('Error fetching account:', error);
        accountCheckError.value = 'Account not found';
    } finally {
        isCheckingAccount.value = false;
    }
};

const handleSubmit = async () => {
    isSubmitting.value = true;
    errorMessage.value = '';

    try {
        const payload = {
            email: email.value,
            role: role.value,
        };

        await (window as any).$app.api.post(`/internal/accounts/${account_id.value}/users`, payload);

        // Clear form on success
        email.value = '';
        role.value = '';
        account_id.value = '';
        accountName.value = '';
        accountCheckError.value = '';

        alert('User added successfully!');
    } catch (error) {
        console.error('Error adding user to account:', error);

        if (error.response?.data?.exception) {
            errorMessage.value = error.response.data.exception;
        } else if (error.response?.data?.description) {
            errorMessage.value = error.response.data.description;
        } else if (error.message) {
            errorMessage.value = error.message;
        } else {
            errorMessage.value = 'Failed to add user to account. Please try again.';
        }
    } finally {
        isSubmitting.value = false;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("form", {
    class: "form m-3 mt-4",
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    _hoisted_1,
    _hoisted_2,
    _createVNode("label", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createVNode("input", {
        type: "email",
        class: "form-control",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (email.value = $event)),
        required: ""
      }, null, 512), [
        [_vModelText, email.value]
      ])
    ]),
    _createVNode("label", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createVNode("select", {
        class: "form-control form-select",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (role.value = $event)),
        required: ""
      }, [
        _hoisted_7
      ], 512), [
        [_vModelSelect, role.value]
      ])
    ]),
    _createVNode("label", _hoisted_12, [
      _hoisted_13,
      _withDirectives(_createVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (account_id.value = $event)),
        required: ""
      }, null, 512), [
        [_vModelText, account_id.value]
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: checkAccountName,
        disabled: !account_id.value || isCheckingAccount.value
      }, _toDisplayString(isCheckingAccount.value ? 'Checking...' : 'Check Account Name'), 9, ["disabled"]),
      (accountName.value)
        ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(accountName.value), 1))
        : _createCommentVNode("", true),
      (accountCheckError.value)
        ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(accountCheckError.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode("button", {
      type: "submit",
      class: "btn btn-primary full-width",
      disabled: isSubmitting.value
    }, _toDisplayString(isSubmitting.value ? 'Adding...' : 'Add'), 9, ["disabled"]),
    (errorMessage.value)
      ? (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true)
  ], 40, ["onSubmit"]))
}
}

})